import script from "./HomeworkPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeworkPage.vue?vue&type=script&setup=true&lang=ts"

import "./HomeworkPage.vue?vue&type=style&index=0&id=12776147&lang=scss"

const __exports__ = script;

export default __exports__